import { atom, useAtom } from "jotai"
import { useCallback } from "react"

const dialogCountAtom = atom<number>(0)

export default function useIsAnyDialogOpen() {
    const [dialogCount, setDialogCount] = useAtom(dialogCountAtom)

    const isAnyDialogOpen = dialogCount > 0

    const setIsAnyDialogOpen = useCallback(
        (isOpen: boolean) => {
            setDialogCount((prevCount) => {
                const newCount = isOpen ? prevCount + 1 : prevCount - 1
                // Prevent negative counts
                return Math.max(0, newCount)
            })
        },
        [setDialogCount],
    )

    return { isAnyDialogOpen, setIsAnyDialogOpen }
}
